/*
 * When the guest turns up, as the booking form asks it.
 */

export const ARRIVAL = {
  /* Accept the entry time on the guest card. */
  DEFAULT: "DEFAULT",
  /* The guest is at the desk; the server stamps the moment we save. */
  NOW: "NOW",
  /* The operator picked a date & time. */
  SCHEDULED: "SCHEDULED",
};
